// Tarot card data with names, descriptions, and image paths
export const tarotCards = [
  {
    id: 1,
    name: "El Mago",
    keywords: "Manifestación, poder, acción",
    description: "El Mago representa el poder de manifestar tus deseos a través de la acción consciente.",
    image: "/images/cards/magician.png"
  },
  {
    id: 2,
    name: "La Sacerdotisa",
    keywords: "Intuición, misterio, sabiduría interior",
    description: "La Sacerdotisa simboliza la sabiduría intuitiva y los misterios ocultos.",
    image: "/images/cards/high-priestess.png"
  },
  {
    id: 3,
    name: "La Emperatriz",
    keywords: "Fertilidad, creatividad, abundancia",
    description: "La Emperatriz representa la abundancia, la creatividad y la nutrición.",
    image: "/images/cards/empress.png"
  },
  {
    id: 4,
    name: "El Emperador",
    keywords: "Autoridad, estructura, control",
    description: "El Emperador simboliza la autoridad, el orden y la estructura.",
    image: "/images/cards/emperor.png"
  },
  {
    id: 5,
    name: "El Sumo Sacerdote",
    keywords: "Tradición, conformidad, creencias",
    description: "El Sumo Sacerdote representa la tradición, la educación y la conformidad.",
    image: "/images/cards/hierophant.png"
  },
  {
    id: 6,
    name: "Los Enamorados",
    keywords: "Elección, amor, relaciones",
    description: "Los Enamorados simbolizan las relaciones, las decisiones y la armonía de opuestos.",
    image: "/images/cards/lovers.png"
  },
  {
    id: 7,
    name: "El Carro",
    keywords: "Determinación, control, éxito",
    description: "El Carro representa la victoria, el control y la determinación.",
    image: "/images/cards/chariot.png"
  },
  {
    id: 8,
    name: "La Fuerza",
    keywords: "Coraje, paciencia, compasión",
    description: "La Fuerza simboliza el coraje, la paciencia y el dominio de las pasiones.",
    image: "/images/cards/strength.png"
  },
  {
    id: 9,
    name: "El Ermitaño",
    keywords: "Introspección, búsqueda, soledad",
    description: "El Ermitaño representa la búsqueda interior, la soledad y la guía espiritual.",
    image: "/images/cards/hermit.png"
  },
  {
    id: 10,
    name: "La Rueda de la Fortuna",
    keywords: "Cambio, ciclos, destino",
    description: "La Rueda de la Fortuna simboliza los ciclos, el cambio y el destino.",
    image: "/images/cards/wheel-of-fortune.png"
  },
  {
    id: 11,
    name: "La Justicia",
    keywords: "Equilibrio, verdad, consecuencias",
    description: "La Justicia representa el equilibrio, la verdad y las consecuencias de nuestras acciones.",
    image: "/images/cards/justice.png"
  },
  {
    id: 12,
    name: "El Colgado",
    keywords: "Rendición, nuevas perspectivas, pausa",
    description: "El Colgado simboliza el sacrificio, la pausa y las nuevas perspectivas.",
    image: "/images/cards/hanged-man.png"
  },
  {
    id: 13,
    name: "La Muerte",
    keywords: "Transformación, fin, renovación",
    description: "La Muerte representa la transformación, el fin de un ciclo y la renovación.",
    image: "/images/cards/death.png"
  },
  {
    id: 14,
    name: "La Templanza",
    keywords: "Moderación, equilibrio, paciencia",
    description: "La Templanza simboliza la moderación, la armonía y la paciencia.",
    image: "/images/cards/temperance.png"
  },
  {
    id: 15,
    name: "El Diablo",
    keywords: "Ataduras, materialismo, sombras",
    description: "El Diablo representa las ataduras, el materialismo y los aspectos sombríos.",
    image: "/images/cards/devil.png"
  },
  {
    id: 16,
    name: "La Torre",
    keywords: "Revelación, caos, despertar",
    description: "La Torre simboliza la revelación repentina, la destrucción y el despertar.",
    image: "/images/cards/tower.png"
  },
  {
    id: 17,
    name: "La Estrella",
    keywords: "Esperanza, inspiración, serenidad",
    description: "La Estrella representa la esperanza, la inspiración y la renovación espiritual.",
    image: "/images/cards/star.png"
  },
  {
    id: 18,
    name: "La Luna",
    keywords: "Ilusión, intuición, subconsciente",
    description: "La Luna simboliza la intuición, el subconsciente y las ilusiones.",
    image: "/images/cards/moon.png"
  },
  {
    id: 19,
    name: "El Sol",
    keywords: "Vitalidad, alegría, éxito",
    description: "El Sol representa la vitalidad, la claridad y el éxito.",
    image: "/images/cards/sun.png"
  },
  {
    id: 20,
    name: "El Juicio",
    keywords: "Renacimiento, llamado interior, absolución",
    description: "El Juicio simboliza el renacimiento, la llamada interior y la absolución.",
    image: "/images/cards/judgement.png"
  },
  {
    id: 21,
    name: "El Mundo",
    keywords: "Realización, integración, viaje",
    description: "El Mundo representa la realización, la integración y la culminación de un viaje.",
    image: "/images/cards/world.png"
  },
  {
    id: 22,
    name: "El Loco",
    keywords: "Nuevo comienzo, libertad, espontaneidad",
    description: "El Loco simboliza los nuevos comienzos, la libertad y la espontaneidad.",
    image: "/images/cards/fool.png"
  }
]; 